const HOST = {
  // GIMI88: ['localhost'],
  GICC: ['gi1234.vip', 'bkkitshop.com'],
  DEFAULT: [],
};

module.exports = {
  HOST,
};
